import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { appContext } from '../App';
import PublicMinerDashboard from '../Components/public/PublicMinerDashboard';

/** /miner/:address — the public dashboard of a segproxy miner, reachable whether or not anyone is signed in. */
export const PublicMiner = () => {
    const { address = '' } = useParams<{ address: string }>();
    const { darkMode, setDarkMode } = useContext(appContext);

    return (
        <div className="flex flex-col min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
            <nav className="sticky top-0 z-50 bg-[#0c2a4a] dark:bg-slate-900 shadow-xl border-b border-white/10 dark:border-slate-700/50 backdrop-blur-md">
                <div className="container mx-auto px-3 sm:px-4 py-2.5 flex items-center justify-between">
                    <Link to="/">
                        <img src="/assets/segpool.png" className="h-7 md:h-9 lg:h-10 transition-all duration-300 hover:scale-105 hover:opacity-90" alt="Logo" />
                    </Link>
                    <button
                        onClick={() => setDarkMode(!darkMode)}
                        className="p-2.5 text-white/70 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-300 group"
                        title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
                    >
                        <FontAwesomeIcon icon={darkMode ? faSun : faMoon} className="text-lg group-hover:scale-110 transition-transform" />
                    </button>
                </div>
            </nav>

            <div className="container mx-auto px-3 sm:px-4 md:px-6 py-4 md:py-8 flex-grow">
                <div className="px-4 mb-2">
                    <p className="text-[10px] md:text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">Wallet Address</p>
                    <p className="font-mono text-sm md:text-base font-bold text-[#0E4D92] dark:text-blue-400 break-all">{address}</p>
                </div>
                <div className="md:bg-white md:dark:bg-slate-800/50 md:rounded-2xl p-0 md:p-8 md:shadow-lg md:border md:border-slate-100 md:dark:border-slate-700/50 md:backdrop-blur-sm">
                    <PublicMinerDashboard key={address} address={address} />
                </div>
            </div>

            <footer className="mt-auto py-6 px-4 bg-slate-50 dark:bg-slate-800/30 border-t border-slate-200 dark:border-slate-700/50">
                <div className="container mx-auto">
                    <p className="text-slate-600 dark:text-slate-400 text-sm font-medium">
                        © {new Date().getFullYear()} Powered by Segments. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default PublicMiner;
